import React from 'react';
import './Contractjob.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const Textcoldescribe6 = () => {
    return(
        <>
        <Container>
            <Row className='textrow'>
                    <Col sm={12} className='textcol'>
                        <h4>Access Top Opportunities</h4>
                        <p>Our partnerships with industry-leading clients and Fortune 500 companies across various
                        sectors such as healthcare, banking, finance, and more, provide you with ample opportunities to
                        secure your ideal role.</p>
                    </Col>
                </Row>
            </Container>
        </>
    )
} 

export default Textcoldescribe6